declare global {
  interface Window {
    dataLayer: DataLayer
    gtag: (action: string, value: unknown, options?: GTagOptions) => void
    google_optimize: GoogleOptimize
  }
}

export interface DataLayer {
  push: (options: DataLayerPushOptions) => unknown
}

export interface DataLayerPushOptions {
  event?: string
  EVEN_COHORT?: string
}

export interface GoogleOptimize {
  get: (id: string) => unknown
}

export interface GTagEventOptions {
  callback?: (value: string, name?: string) => void
  event_category?: string
  name?: string
}

export type GTagOptions = GTagEventOptions

export const GTagEventCategory = 'experiments'

export enum GTagAction {
  Event = 'event',
}

export interface Experiment {
  activationEvent?: string
  id: string
  objectiveEvent?: string
  variants: { [key: string]: Variant }
}

export interface Variant {
  id: string
}
